import { render, staticRenderFns } from "./InformationSec.vue?vue&type=template&id=5b28fda9&scoped=true"
import script from "./InformationSec.vue?vue&type=script&lang=js"
export * from "./InformationSec.vue?vue&type=script&lang=js"
import style0 from "./InformationSec.vue?vue&type=style&index=0&id=5b28fda9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28fda9",
  null
  
)

export default component.exports